import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Building2, Car, ArrowLeft } from 'lucide-react';
import { BrandHero, CheckList, CtaBand } from '@/components/brand/BrandKit';

const PORTALS = [
  { icon: Building2, title: 'بوابة عملاء الشركات', desc: 'إدارة أسطولك، ومتابعة الفواتير، واستعراض التقارير، وطلب مركبات إضافية من لوحة تحكم مركزية واحدة.', features: ['نظرة عامة على الأسطول ومدد العقود', 'الفواتير وسجل المدفوعات', 'طلب مركبات جديدة', 'تحميل التقارير'] },
  { icon: Car, title: 'بوابة السائقين والشركاء', desc: 'الوصول إلى جداول المهام، ومتابعة الأداء، والتواصل مع فريق العمليات.', features: ['المهام اليومية والجداول', 'مقاييس الأداء', 'الوثائق والامتثال', 'التواصل مع فريق الدعم'] },
];

export default function PortalPageAr() {
  useEffect(() => { document.title = 'بوابات العملاء والشركاء | مجموعة يوروجلف للتنقل'; }, []);
  return (
    <div dir="rtl" data-testid="portal-page-ar">
      <BrandHero testid="ar-portal-hero" chip="بوابات آمنة" title="بوابات العملاء والشركاء." lead="بوابات آمنة لعملاء الشركات والسائقين والشركاء. الوصول عبر الإنترنت قادم قريباً؛ وفي الوقت الحالي يمكنكم التواصل مع مدير حسابكم للحصول على الكشوفات والتقارير والمهام." image="/brand/control-room-dubai.jpg" position="center 50%" />
      <section className="bg-[#FAFAFA] py-14 sm:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PORTALS.map((p, i) => (
            <div key={p.title} data-testid={`ar-portal-card-${i}`} className="rounded-2xl border border-black/[0.06] bg-white p-7 sm:p-8">
              <p.icon className="w-6 h-6 text-[#EE5A01]" />
              <h2 className="mt-5 font-heading font-bold text-xl text-[#121212]">{p.title}</h2>
              <p className="mt-2 font-body text-sm text-[#666666] leading-relaxed">{p.desc}</p>
              <CheckList className="mt-5" items={p.features} />
              <div className="mt-6 rounded-xl border border-[#EE5A01]/20 bg-[#FFF4ED]/70 p-4">
                <p className="font-heading font-bold text-[11px] tracking-wider text-[#EE5A01]">قريباً</p>
                <p className="mt-1 font-body text-xs text-[#666666]">الوصول الرقمي لهذه البوابة قيد التطوير. للحصول على المساعدة الآن، تواصل مع فريقنا مباشرة.</p>
                <Link to="/ar/contact" data-testid={`ar-portal-contact-${i}`} className="mt-3 inline-flex items-center gap-1 font-heading font-bold text-xs text-[#EE5A01] hover:gap-2 transition-all">تواصل مع فريقنا <ArrowLeft className="w-3 h-3" /></Link>
              </div>
            </div>
          ))}
        </div>
      </section>
      <CtaBand eyebrow="نحن ننقلك!" title="هل تحتاج إلى وصول فوري؟" desc="للحصول على تقارير أسطولك أو جدول مهامك الآن، اتصل على 800 364 أو راسلنا عبر البريد الإلكتروني." ctas={[{ label: 'اتصل بنا', href: '/ar/contact' }, { label: 'اتصل 800 364', href: 'tel:800364', external: true, variant: 'outline' }]} />
    </div>
  );
}
